import * as DisplaySettings from "./settings/DisplaySettings";
import * as States from "./states/States";
import BootState from "./states/BootState";
import SharedLoadState from "./states/SharedLoadState";
import ColoringState from "./states/ColoringState";
import StoryCircleState from "./states/StoryCircleState";
import TitleState from "./states/TitleState";
import RecapState from "./states/RecapState";
import PostGameState from "./states/PostGameState";
import CongratulationState from "./states/CongratulationState";

export default class SRGame {
    constructor() {
        this.name = "Sesame Street Story Circle";
        this.game = new Phaser.Game(
            DisplaySettings.screenWidth,
            DisplaySettings.screenHeight,
            Phaser.CANVAS,
            DisplaySettings.containerId
        );

        this.game.state.add(States.BOOT, BootState);
        this.game.state.add(States.SHARED_LOAD, SharedLoadState);
        this.game.state.add(States.COLORING, ColoringState);
        this.game.state.add(States.STORYCIRCLE, StoryCircleState);
        this.game.state.add(States.TITLE, TitleState);
        this.game.state.add(States.RECAP, RecapState);
        this.game.state.add(States.POSTGAME, PostGameState);
        this.game.state.add(States.CONGRATULATIONS, CongratulationState);

        this.game.state.start(States.BOOT);
    }
}
